export const SUP_COLORS = {
  Bestway: "#2563EB", Costcutter: "#16A34A", "CN Foods": "#9333EA", Booker: "#DC2626",
  "Davis & Dann": "#0891B2", "Auguste Noel": "#D97706", Dhamecha: "#EA580C",
};

export const supName = (id) =>
  ({ bestway: "Bestway", costcutter: "Costcutter", cn_foods: "CN Foods", booker: "Booker",
     davis_and_dann: "Davis & Dann", auguste_noel: "Auguste Noel", dhamecha: "Dhamecha" }[id] || id);

export const supColor = (name) => SUP_COLORS[name] || "#2563EB";

export const CATEGORIES = [
  "Special Offers", "Chilled & Fresh", "Frozen",
  "Drinks & Beverages", "Crisps & Snacking", "Bakery & Grocery",
];

export const INVENTORY_FILTERS = [
  { id: "low", label: "Low Stock Alert (< 30%)" },
  { id: "dead", label: "Dead Stock (30+ days)" },
  { id: "promo", label: "Top Promotional Deals" },
];

export const SUPPLIER_FILTERS = ["CN Foods", "Costcutter", "Cash & Carry List"];

// Temperature quick-filter pills (map to product.temperature)
export const TEMP_FILTERS = [
  { id: "ambient", label: "Ambient" },
  { id: "chilled", label: "Chilled" },
  { id: "frozen", label: "Frozen" },
];

// Horizontal scrolling category pills for the scanner
export const CATEGORY_PILLS = [
  { id: "offer", label: "Special Offer" },
  { id: "Ambient", label: "Ambient", temp: "ambient" },
  { id: "Chilled", label: "Chilled", temp: "chilled" },
  { id: "Frozen", label: "Frozen", temp: "frozen" },
];

// VAT category filter pills
export const VAT_FILTERS = [
  { id: "zero", label: "Zero VAT Items", rate: 0 },
  { id: "standard", label: "Standard 20% VAT", rate: 0.2 },
];

// UK standard VAT
export const VAT_RATE = 0.2;
export const incVat = (net) => +(net * (1 + VAT_RATE)).toFixed(2);
